<template>
    <a href="#" @click="toggle" class="header__item header__item--link" :aria-expanded="isOpen">
        <h1 class="header__title"><a :href="channel.url" class="header__title__link">{{ channel.name }}</a></h1>
        <icon type="chevron-bottom" color="gray" size="16" />

        <ul role="menu" v-if="isOpen" class="dropdown-menu dropdown-menu--small dropdown-menu--left" :aria-expanded="isOpen">
            <li class="dropdown-menu__item">
                <a class="dropdown-menu__link" :href="channel.settings_url">Channel Settings</a>
            </li>

            <!--TODO: If user is not currently on the channel kanban / list view-->
            <li class="dropdown-menu__item">
                <a class="dropdown-menu__link" :href="channel.url">Back</a>
            </li>
        </ul>
    </a>
</template>

<script>
import Toggleable from '../../mixins/toggle'
import Icon from '../Global/Icon'
import { mapState } from 'vuex'


export default {
    name: "ChannelNavigation",

    mixins: [Toggleable],

    components: {
        Icon
    },

    computed: {
        ...mapState('channel', ['channel']),
    }
}
</script>

<style scoped>

</style>